module.exports = __webpack_public_path__ + "static/media/tamSat.ab6112e9.png";